import React from 'react';

const Repository: React.FC = () => (
  <h1>Repository</h1>
);

export { Repository };
